import React from "react";
import { Card } from "react-bootstrap";
import styled from "styled-components";

const SkeletonCard = styled(Card)`
  height: 400px;
  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  border: none;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;

const SkeletonContent = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SkeletonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

const SkeletonBadge = styled.div`
  width: 80px;
  height: 24px;
  background-color: #d0d0d0;
  border-radius: 12px;
  animation: pulse 1.5s ease-in-out infinite alternate;
`;

const SkeletonValue = styled.div`
  width: 100px;
  height: 28px;
  background-color: #d0d0d0;
  border-radius: 4px;
  animation: pulse 1.5s ease-in-out infinite alternate;
`;

const SkeletonTitle = styled.div`
  width: 70%;
  height: 32px;
  background-color: #d0d0d0;
  border-radius: 4px;
  margin-bottom: 12px;
  animation: pulse 1.5s ease-in-out infinite alternate;
`;

const SkeletonDescription = styled.div`
  width: 90%;
  height: 20px;
  background-color: #d0d0d0;
  border-radius: 4px;
  margin-bottom: 8px;
  animation: pulse 1.5s ease-in-out infinite alternate;
`;

const SkeletonDescriptionShort = styled.div`
  width: 60%;
  height: 20px;
  background-color: #d0d0d0;
  border-radius: 4px;
  margin-bottom: 24px;
  animation: pulse 1.5s ease-in-out infinite alternate;
`;

const SkeletonStats = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
`;

const SkeletonStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SkeletonStatLabel = styled.div`
  width: 80px;
  height: 16px;
  background-color: #d0d0d0;
  border-radius: 4px;
  animation: pulse 1.5s ease-in-out infinite alternate;
`;

const SkeletonStatValue = styled.div`
  width: 60px;
  height: 20px;
  background-color: #d0d0d0;
  border-radius: 4px;
  animation: pulse 1.5s ease-in-out infinite alternate;
`;

const SkeletonHoldings = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

const SkeletonHolding = styled.div`
  width: 32px;
  height: 32px;
  background-color: #d0d0d0;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite alternate;
`;

const SkeletonAuthor = styled.div`
  width: 120px;
  height: 18px;
  background-color: #d0d0d0;
  border-radius: 4px;
  animation: pulse 1.5s ease-in-out infinite alternate;
`;

const SkeletonStyles = styled.div`
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

const HeroCardSkeleton = () => {
  return (
    <>
      <SkeletonStyles />
      <SkeletonCard>
        <SkeletonContent>
          <div>
            <SkeletonHeader>
              <SkeletonBadge />
              <SkeletonValue />
            </SkeletonHeader>

            <SkeletonTitle />
            <SkeletonDescription />
            <SkeletonDescriptionShort />

            <SkeletonStats>
              <SkeletonStat>
                <SkeletonStatLabel />
                <SkeletonStatValue />
              </SkeletonStat>
              <SkeletonStat>
                <SkeletonStatLabel />
                <SkeletonStatValue />
              </SkeletonStat>
            </SkeletonStats>

            <SkeletonHoldings>
              <SkeletonHolding />
              <SkeletonHolding />
              <SkeletonHolding />
              <SkeletonHolding />
            </SkeletonHoldings>
          </div>

          <SkeletonAuthor />
        </SkeletonContent>
      </SkeletonCard>
    </>
  );
};

export default HeroCardSkeleton;
